'use client';

import type { Dispatch, SetStateAction } from 'react';
import type { User } from '@/types/user/type';
import type { UpdatingCriteriasState } from '~/components/Profile/model';
import { VpButton } from '@vtmn-play/react/headless';
import { useTranslations } from 'next-intl';
import { useNavigationGuard } from 'next-navigation-guard';
import { Loader } from '@/app/components/Loader';
import { GenericDialog } from '~/components/commons/genericDialog/GenericDialog';

export const Submit = ({
  user,
  handleUserPutData,
  canBeSubmitted,
  isLoading,
  setUserUpdatingData,
  setUpdatingData,
}: {
  user: Partial<User>;
  handleUserPutData: () => Promise<void>;
  canBeSubmitted: boolean;
  isLoading: boolean;
  setUserUpdatingData: Dispatch<SetStateAction<Partial<User>>>;
  setUpdatingData?: Dispatch<SetStateAction<UpdatingCriteriasState>>;
}) => {
  const t = useTranslations();

  const { active, accept } = useNavigationGuard({
    enabled: canBeSubmitted,
  });

  return (
    <div className="profile__action">
      <VpButton
        id="submit"
        data-testid="submit"
        disabled={!canBeSubmitted}
        shape="squared"
        onClick={handleUserPutData}
      >
        {isLoading && <Loader inverted />}
        {' '}
        {t('GLOBAL.ACTIONS.SAVE')}
      </VpButton>
      <GenericDialog
        isOpen={active}
        isClosable={false}
        content={t('PROFILE.GLOBAL.UNSAVED_CHANGES')}
        primaryButtonTitle={t('GLOBAL.ACTIONS.SAVE')}
        primaryButtonClick={async () => {
          await handleUserPutData();
          accept();
        }}
        secondaryButtonTitle={t('PROFILE.GLOBAL.DO_NOT_SAVE')}
        secondaryButtonClick={() => {
          setUserUpdatingData(user);

          if (setUpdatingData) {
            setUpdatingData({});
          }
          accept();
        }}
        isLoading={isLoading}
        title={t('PROFILE.GLOBAL.WARNING')}
      />
    </div>
  );
};
